import { useEffect, useMemo } from 'react'

import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { useCookieConsentAnswer } from '~/shared/hooks/useCookieConsentAnswer'
import { usePageInfo } from '~/shared/providers/PageInfoProvider'
import { selectApplovinPixelId } from '~/shared/store/common'

export const useApplovinPixel = () => {
  const applovinPixelId = useSelector(selectApplovinPixelId)

  const { pathname } = useLocation()
  const { currentPageId } = usePageInfo()
  const { isEUUser, hasAdvertisingAndTargetingCookie, cookieConsent } =
    useCookieConsentAnswer()

  const shouldAxonPixelBePaused = useMemo(
    () =>
      (isEUUser && !cookieConsent?.length) ||
      (isEUUser && !hasAdvertisingAndTargetingCookie),
    [isEUUser, cookieConsent?.length, hasAdvertisingAndTargetingCookie],
  )

  useEffect(() => {
    if (!currentPageId || !applovinPixelId || shouldAxonPixelBePaused) return

    const axonScript = document.createElement('script')
    axonScript.async = true
    axonScript.type = 'text/javascript'

    axonScript.text = `
      !function(e,r){
        var t=["https://s.axon.ai/pixel.js","https://c.albss.com/p/l/loader.iife.js"];
        if(!e.axon){
          const AXON_EVENT_KEY = '${applovinPixelId}';
          var a=e.axon=function(){
            a.performOperation?a.performOperation.apply(a,arguments):a.operationQueue.push(arguments)
          };
          a.operationQueue=[],a.ts=Date.now(),a.eventKey=AXON_EVENT_KEY;
          for(var n=r.getElementsByTagName("script")[0],o=0;o<t.length;o++){
            var i=r.createElement("script");
            i.async=!0,i.src=t[o],n.parentNode.insertBefore(i,n)
          }
        }
      }(window,document);
      axon("init");
    `
    document.body.appendChild(axonScript)
  }, [currentPageId, applovinPixelId, shouldAxonPixelBePaused])

  useEffect(() => {
    window?.axon?.('track', 'page_view')
  }, [pathname])
}
